/*
 * @Author: error: git config user.name && git config user.email & please set dead value or install git
 * @Date: 2022-05-25 15:08:47
 * @LastEditors: error: git config user.name && git config user.email & please set dead value or install git
 * @LastEditTime: 2022-12-27 17:14:21
 * @FilePath: \githubd:\工作代码\sessionSVGVue\src\main.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import Cube from 'cube-ui'
import router from './router'
import Api from './api/index' //ajax组件
import VueAMap from 'vue-amap';
Vue.use(Api)
Vue.use(Cube)
Vue.use(VueAMap)
VueAMap.initAMapApiLoader({
  key: '24f0a4688adbcacbeeab5890e36b30c6',
  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor', 'AMap.Geolocation'],
  uiVersion: '1.0.11' // 版本号
});
import fontSizeRem from "./utils/remtopx.js";
Vue.prototype.fontSizeRem = fontSizeRem
const snap = require(`imports-loader?this=>window,fix=>module.exports=0!snapsvg/dist/snap.svg.js`);
Vue.config.productionTip = false

Vue.prototype.$Post = function (url, postObj, success, failure, isShowLoding, text = "加载中") {
  var _this = this
  this.$http.post(url, postObj, function (msg) {
    success(msg)
  }, function (err) {
    failure(err)
  })
}
Vue.prototype.$alertShow = function (msg, text) {
  this.$createDialog({
    type: 'alert',
    title: '温馨提示',
    confirmBtn: {
      text: text ? text : '确定',
      active: true,
      disabled: false,
      href: 'javascript:;'
    },
    content: msg,
  }).show()
}

//检查是否是移动端（Mobile）、ipad、iphone、微信、QQ等
var browser = {
  versions: function () {
    var u = navigator.userAgent,
      app = navigator.appVersion;
    return {
      trident: u.indexOf('Trident') > -1, //IE内核
      presto: u.indexOf('Presto') > -1, //opera内核
      webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
      gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1,//火狐内核
      mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
      ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
      android: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1, //android终端
      iPhone: u.indexOf('iPhone') > -1, //是否为iPhone或者QQHD浏览器
      iPad: u.indexOf('iPad') > -1, //是否iPad
      webApp: u.indexOf('Safari') == -1, //是否web应该程序，没有头部与底部
      weixin: u.indexOf('MicroMessenger') > -1, //是否微信 （2015-01-22新增）
      qq: u.match(/\sQQ/i) == " qq" //是否QQ
    };
  }(),
  language: (navigator.browserLanguage || navigator.language).toLowerCase()
}

router.beforeEach(function (to, from, next) {
  to.params.browser = browser
  if (to.query.title) {
    to.meta.title = to.query.title
    document.title = to.meta.title
    if (browser.versions.ios && window.changeWebViewTitle) {
      window.changeWebViewTitle(to.meta.title)
    }
  } else if (!!to.meta.title) {
    document.title = to.meta.title
    if (browser.versions.ios && window.changeWebViewTitle) {
      window.changeWebViewTitle(to.meta.title)
    }
  }
  next();
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  snap,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js